import jQuery from 'jquery';
let $ = jQuery;

import "./Widget.js";

// define EVENTs
import "./PaymentManagement.js";
    
/**
    * class HSN.Widget.FlexPayOrder
    *
    * Encapsulates the common functionality of the FlexPayOrder Widget.
    **/
HSN.Widget.FlexPayOrder = function () {
    var application;
    var container;
    var accountService;
    var deviceInformation;
    var orderIdentity;
    var flexPaymentNumber;
    var flexPaymentMonth;
    /**
        * new HSN.Widget.FlexPayOrder.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.FlexPayOrder]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        accountService = application._getAccountService();
        deviceInformation = application.DeviceInformation;
        orderIdentity = config.orderIdentity;
        flexPaymentNumber = config.flexPaymentNumber;
        flexPaymentMonth = config.flexPaymentMonth;

        SetMyEventHandlers();

        bindEvents();
    }

    function bindEvents() {
        container.on('click', '.pay-now', function () {
            var paymentNumbers = [];

            $('.payment-check .pay-now-check:checked', container).each(function () {
                paymentNumbers.push($(this).closest('.payment-line').data('payment-number'));
            });

            if (deviceInformation.IsMobile) {
                var flexPayNumbers = paymentNumbers;
                var data = { flexPayNumbers: flexPayNumbers };
                var paramNumbers = $.param(data, true);
                window.location.href = '/myaccount/flexpay-manager/pay-now/' + orderIdentity + '?' + paramNumbers;
            }
            else {
                application.GetFlexPayManagerPayNowModal().Show({
                    orderIdentity: orderIdentity,
                    data: {
                        flexPayNumbers: paymentNumbers
                    }
                });
            }

            paymentNumbers = [];
        });
        container.on('click', '.change-card', function () {
            if (deviceInformation.IsMobile) {
                window.location.href = '/myaccount/flexpay-manager/payment/' + orderIdentity + '/' + flexPaymentNumber + '/' + flexPaymentMonth;
            }
            else {
                ToggleContainer(1);
            }
            return false;
        });
        container.on('click', '.payment-check .pay-now-check', function () {
            application.Events.Trigger(HSN.Widget.FlexPayOrder.EVENT.CLEAR_PAY_NOW, orderIdentity);
            var wasChecked = this.checked;
            UncheckAll('.payment-check .pay-now-check');
            CheckUpUntil('.payment-check .pay-now-check', this);
            if (!wasChecked) {
                $(this).val(wasChecked);
                this.checked = wasChecked;
            }
            TogglePayNow('.payment-check .pay-now-check');
        });
        container.on('keypress', 'label.payment-totals', function (e) {
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (keycode != 32) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            $('#' + $(this).attr('for')).click();
        });
        container.on('click', '.show-details-link', function () {
            if (deviceInformation.IsMobile) {
                ToggleContainer(1);
            }
            return false;
        });
        container.on('click', '.cancel-show-details-link', function () {
            if (deviceInformation.IsMobile) {
                ToggleContainer(1);
            }
            return false;
        });
    }

    function CheckUpUntil(selector, thisInput) {
        $(selector, container).each(function () {
            this.checked = true;
            $(this).val(true);
            if (this === thisInput) {
                return false;
            }
            return true;
        });
    }

    function UncheckAll(selector) {
        $(selector, container).each(function () {
            this.checked = false;
            $(this).val(false);
        });
    }

    function TogglePayNow(selector) {
        var total = parseFloat(0);
        var checkedSelector = selector + ':checked';
        if ($(checkedSelector, container).length > 0) {
            $(checkedSelector, container).each(function () {
                total += parseFloat($(this).closest('.payment-line').data('total-due'));
            });
            $('.payment-total', container).text(HSN.FormatCurrency(total, 2));
            $('.payment-action', container).toggle(true);
        }
        else {
            $('.payment-action', container).toggle(false);
            $('.payment-total', container).text(total);
        }
    }

    function HandlePaymentSelected(paymentIdentity, eventIdentity) {
        if (orderIdentity !== eventIdentity) {
            return;
        }
        HSN.SetWait();
        ChangePayment(paymentIdentity);
    }
    function HandlePaymentAdded(data) {
        if (!data.isAdd) {
            return;
        }
        HSN.SetWait();
        ChangePayment(data.paymentIdentity);
    }
    function ChangePayment(paymentIdentity) {
        var requestData = {
            orderIdentity: orderIdentity,
            flexPaymentNumber: flexPaymentNumber,
            paymentIdentity: paymentIdentity
        }
        accountService.FlexPayChangePayment(requestData, {
            callback: function (data) {
                if (data.success) {
                    Refresh();
                }
                else {
                    HSN.CheckoutHandleError(container, data, 'Unfortunately there was an error attempting to update your payment information, please try again.');
                }
            },
            errorCallback: function () {
                HSN.CheckoutHandleError(container, {}, 'Unfortunately there was an error attempting to update your payment information, please try again.');
            },
            scope: this
        });
    }
    function HandleRefresh(eventIdentity) {
        if (orderIdentity !== eventIdentity) {
            return;
        }
        Refresh();
    }
    function HandleClearPayNow(eventIdentity) {
        if (orderIdentity !== eventIdentity) {
            UncheckAll('.payment-check .pay-now-check');
            $('.payment-action', container).toggle(false);
            $('.payment-total', container).text(0);
        }
    }

    function ClearChildEventHandlers() {
    }
    function ClearMyEventHandlers() {
        application.Events.Off(HSN.Widget.PaymentManagement.EVENT.SELECTED, null, orderIdentity);
        application.Events.Off(HSN.Widget.PaymentManagement.EVENT.ADD_NEW_PAYMENT_COMPLETE, null, orderIdentity);
    }
    function SetMyEventHandlers() {
        application.Events.On(HSN.Widget.PaymentManagement.EVENT.SELECTED, HandlePaymentSelected, orderIdentity);
        application.Events.On(HSN.Widget.PaymentManagement.EVENT.ADD_NEW_PAYMENT_COMPLETE, HandlePaymentAdded, orderIdentity);
        application.Events.On(HSN.Widget.FlexPayOrder.EVENT.REFRESH, HandleRefresh, orderIdentity);
        application.Events.On(HSN.Widget.FlexPayOrder.EVENT.CLEAR_PAY_NOW, HandleClearPayNow, orderIdentity);
    }
    function ToggleContainer(index) {
        var identifier = orderIdentity + '-' + index;
        var toggleContainer = $("[toggleindex='" + identifier + "']", container);
        var isAjax = toggleContainer.hasClass('ajax');
        var ajaxUrl = toggleContainer.data('url');
        var targetContainer = $('.container-wrap', toggleContainer);
        var scrollOffset = 0;

        if (deviceInformation.IsMobile) {
            if (toggleContainer.is(':visible')) {
                scrollOffset = $('.toggleWrap', container).outerHeight();
            }
            scrollOffset = scrollOffset + HSN.GetMobileHeaderOffset() + 7; //wiggle room
        }
        else {
            scrollOffset = scrollOffset + HSN.GetDesktopStickyHeaderOffset();
        }

        HSN.AnimateAccordion('toggleContainer', identifier, false, true, {
            scrollOffset: scrollOffset,
            fadeOutCallback: function () {
                if (isAjax) {
                    targetContainer.html('');
                }
            },
            beforeFadeIn: function () {
                if (isAjax) {
                    LoadAjaxContainer(ajaxUrl, toggleContainer, targetContainer, scrollOffset);
                }
            }
        });
    }
    function LoadAjaxContainer(ajaxUrl, toggleContainer, targetContainer, scrollOffset) {
        ClearMyEventHandlers();
        HSN.SetContainerWait($('.container-wrap', toggleContainer));
        var topOffset = toggleContainer.parent().offset().top;
        $.ajax
        (
            ajaxUrl,
            {
                type: 'GET',
                data: { '_ts': new Date().getTime() },
                context: this,
                dataType: 'html',
                success: function (responseData) {
                    HSN.RemoveContainerWait();
                    targetContainer.html(responseData);
                    SetMyEventHandlers();
                    $('html,body').animate({ scrollTop: topOffset - scrollOffset }, 'slow');
                    $('.change-payment-description').focus();
                },
                error: function () {
                    alert('Unfortunately there was an error attempting to load the content, please try again.');
                    HSN.RemoveContainerWait();
                }
            }
        );
    }
    function CloseAllDrawers() {
        $('.toggleContainer', container).each(function () {
            if ($(this).is(':visible')) {
                ToggleContainer($(this).attr('toggleindex').split('-')[1]);
            }
        });
    }
    function Refresh() {
        HSN.SetWait();
        CloseAllDrawers();
        if (deviceInformation.IsMobile) {
            if (window.location.pathname === '/myaccount/flexpay-manager') {
                window.location.reload();
            }
            else {
                window.location.href = '/myaccount/flexpay-manager#flexpay-container-' + orderIdentity;
            }
        }
        else {
            container.parent().append('<div class="refresh-mask"></div>');
            HSN.SetContainerWait($('.refresh-mask', container.parent()), false);
            var contentWrap = container.parent();
            accountService.FlexPayGetOrder(orderIdentity, {
                callback: function (data) {
                    Destroy();
                    contentWrap.html(data);
                    $('html,body').animate({
                        scrollTop: contentWrap.offset().top
                    }, 500);
                    $('.refresh-mask', container.parent()).remove();
                },
                errorCallback: function () {
                    $('.refresh-mask', container.parent()).remove();
                },
                scope: this
            });
            HSN.RemoveWait();
        }
    }
    function Destroy() {
        ClearMyEventHandlers();
        ClearChildEventHandlers();
    }
    return {
        init: init,
        Refresh: Refresh,
        Destroy: Destroy
    }
};

HSN.Widget.FlexPayOrder.EVENT = {
    CANCELLED: 'HSN.Widget.FlexPayOrder:CANCELLED',
    REFRESH: 'HSN.Widget.FlexPayOrder:REFRESH',
    CLEAR_PAY_NOW: 'HSN.Widget.FlexPayOrder:CLEAR_PAY_NOW'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/FlexPayOrder.js